import { Directive, HostBinding } from "@angular/core";

@Directive({
  selector: "[appScrollFixLeft]",
})
export class AppDragFixLeftDirective {
  public leftPosition: number = 0;

  @HostBinding("style.transform") get transform(): string {
    return `translate(${this.leftPosition}px)`;
  }
}
